<template>
  <div class="row">
    <div class="flex xs12 md12 c-position">
      <sliding-pagination
        :current="parseInt(currentPage)"
        :total="parseInt(totalPages)"
        :style="cssVars"
        @page-change="onChange"
        v-if="totalPages > 0"
      ></sliding-pagination>
    </div>
  </div>
</template>

<script>

import SlidingPagination from 'vue-sliding-pagination'

export default {
  components: {
    SlidingPagination
  },
  props: ["currentPage", "totalPages", "onChange"],

  computed: {
    cssVars() {
      return {
        '--secondary-color': this.$themes.secondary,
        '--primary-color': this.$themes.primary,
      }
    },
  }
}
</script>

<style lang="scss">

@import "~vue-sliding-pagination/dist/style/vue-sliding-pagination.css";

.c-position {  
  width:100%;
  margin:0 auto;
  text-align:center;
}

.c-sliding-pagination__list * {
  padding: 0px;
  margin: 0px;
}

.c-sliding-pagination__page {
  padding: 10px 10px 10px 10px;
  border-radius: 10%;
}

.c-sliding-pagination__list :hover {
  background-color: var(--secondary-color);
}

.c-sliding-pagination__list-element {
  margin-left: 5px;
  border: 1px solid;
  background-color: #FFF;
  color: var(--secondary-color);
  padding: 10px 1px 10px 1px;
}

.c-sliding-pagination__list-element--active {
  background-color: var(--secondary-color);
  color: var(--primary-color);
}
</style>
